import { Components } from "appworks/components/components";
import { TGRFakeSymbolValueComponent } from "components/tgr-fake-symbol-value";
import { TGRInstantWinResult } from "integration/builders/results/tgr-instant-win-result";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";
import { DataProcessorSupplement } from "slotworks/model/gameplay/supplements/data-processor-supplement";

export class TGRInstantWinsSupplement implements DataProcessorSupplement {

    public active: boolean = true;

    public process(record: SpinRecord): void {
        if (!this.active || !record.grid) {
            return;
        }
        const result: TGRInstantWinResult = record.getFirstResultOfType(TGRInstantWinResult);
        if (result) {
            const tgrFakeSymbolValueComponent: TGRFakeSymbolValueComponent = Components.get(TGRFakeSymbolValueComponent);
            let index: number = 0;
            record.grid.forEach((col: string[], x: number) => col.forEach((symId: string, y: number) => {
                if (symId === "QH") {
                    record.grid[x][y] = tgrFakeSymbolValueComponent.getRealQHSymbolId(result.instantWins[index++].showingAmount);
                }
            }));
        }
    }
}
